import React from 'react'

export const VenteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M4 3a3 3 0 00-3 3v8a3 3 0 003 3h12a3 3 0 003-3V7H4v2h13v5a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1h2a3 3 0 00-3-3H4z"></path>
      <path d="M15 11h-4v2h4v-2z"></path>
    </svg>
  );
}